import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`

let api = {
  // 获取设备数量
  getDeviceOverview: `${baseUrl}/overview/getDeviceOverview`,

  // 设备列表
  getDeviceList: `${baseUrl}/overview/deviceList`,

  // 获取容量占比
  getDeviceCapcity: `${baseUrl}/overview/getDeviceCapcity`,

  // 获取电量
  getUsedElectricity: `${baseUrl}/overview/getUsedElectricity`,

  // 监测数据
  getRunMonitor: `${baseUrl}/overview/getRunMonitor`,

  // 监测数据
  getSiteRunMonitor: `${baseUrl}/siteRunMonitor/getRunMonitor`,

  // 添加配电房
  addPowerRoom: `${baseUrl}/place/add`,

  // 监控设备列表
  getVideoDeviceList: `${baseUrl}/place/getVideoDeviceList`,

  // 修改配电房
  updatePowerRoom: `${baseUrl}/powerRoom/update`,

  // 删除配电房
  deletePowerRoomByCodes: `${baseUrl}/place/del`,

  // 场所管理分页
  getPowerRoomPage: `${baseUrl}/place/getPage`,

  // 场所管理修改
  updatePlace: `${baseUrl}/place/update`,

  // 查询配电房详情
  getPowerRoomByCode: `${baseUrl}/place/getByCode`,

  // 查询配电房列表
  getPowerRoomList: `${baseUrl}/powerRoom/getList`,

  // 添加环境网关
  addEnvironmentGateway: `${baseUrl}/gatewayDevice/add`,

  // 修改环境网关
  updateEnvironmentGateway: `${baseUrl}/gatewayDevice/update`,

  // 删除环境网关
  deleteEnvironmentGatewayByCodes: `${baseUrl}/gatewayDevice/del`,

  // 网关设备分页
  getEnvironmentGatewayPage: `${baseUrl}/gatewayDevice/getPage`,

  // 查询环境网关详情
  getEnvironmentGatewayByCode: `${baseUrl}/gatewayDevice/getByCode`,

  // 查询环境网关列表
  getEnvironmentGatewayList: `${baseUrl}/environmentGateway/getList`,

  // 添加电压采集网关
  addEnergyGateway: `${baseUrl}/energyGateway/add`,

  // 修改电压采集网关
  updateEnergyGateway: `${baseUrl}/energyGateway/update`,

  // 删除电压采集网关
  deleteEnergyGatewayByCodes: `${baseUrl}/energyGateway/deleteByCodes`,

  // 查询电压采集网关分页
  getEnergyGatewayPage: `${baseUrl}/energyGateway/getPage`,

  // 查询电压采集网关详情
  getEnergyGatewayByCode: `${baseUrl}/energyGateway/getByCode`,

  // 查询电压采集网关列表
  getEnergyGatewayList: `${baseUrl}/energyGateway/getList`,

  // 状态式探测器添加
  addStatusDetector: `${baseUrl}/statusDetector/add`,

  // 状态式探测器修改
  updateStatusDetector: `${baseUrl}/statusDetector/update`,

  // 触发式探测器添加
  addTouchDetector: `${baseUrl}/touchDetector/add`,

  // 触发式探测器修改
  updateTouchDetector: `${baseUrl}/touchDetector/update`,

  // 配电式探测器添加
  addPowerDetector: `${baseUrl}/powerDetector/add`,

  // 配电式探测器修改
  updatePowerDetector: `${baseUrl}/powerDetector/update`,

  // 泵探测器添加
  addPumpDetector: `${baseUrl}/pumpDetector/add`,

  // 泵探测器修改
  updatePumpDetector: `${baseUrl}/pumpDetector/update`,

  // 修改配电柜
  updatePowerBox: `${baseUrl}/powerBox/update`,

  // 删除配电柜
  deletePowerBoxByCodes: `${baseUrl}/powerBox/deleteByCodes`,

  // 查询配电柜分页
  getPowerBoxPage: `${baseUrl}/powerBox/getPage`,

  // 查询配电柜详情
  getPowerBoxList: `${baseUrl}/powerBox/getList`,

  // 查询配电柜详情
  getPowerBoxByCode: `${baseUrl}/powerBox/getByCode`,

  // 查询环境监测
  getEnvironmentMonitorList: `${baseUrl}/environmentMonitor/getList`,

  // 视频预览
  preview: `${baseUrl2}/videoDevice/preview`,

  // 大华视频预览
  getVideoHlsStream: `${baseUrl2}/videoDevice/getVideoHlsStream`,

  // 查询阈值配置
  getEnergyThresholdConfig: `${baseUrl}/energyThresholdConfig/get`,

  // 修改阈值配置
  updateEnergyThresholdConfig: `${baseUrl}/energyThresholdConfig/update`,

  // 报警记录分页
  getEnergyAlarmRecordPage: `${baseUrl}/alarm/getPage`,

  // 添加报警记录
  addEnergyAlarmRecord: `${baseUrl}/energyAlarmRecord/add`,

  // 获取责任人
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 设备状态日志
  getEnergyDeviceStatusPage: `${baseUrl}/deviceStatus/getPage`,

  // 导出设备状态日志
  exportEnergyDeviceStatus: `${baseUrl}/deviceStatus/export`,

  // 状态式探测器分页
  getStatusDetectorPage: `${baseUrl}/statusDetector/getPage`,

  // 触发式探测器分页
  getTouchDetectorPage: `${baseUrl}/touchDetector/getPage`,

  // 配电探测器分页
  getPowerDetectorPage: `${baseUrl}/powerDetector/getPage`,

  // 泵探测器分页
  getPumpDetectorPage: `${baseUrl}/pumpDetector/getPage`,

  // 所有场景
  getPlaceList: `${baseUrl}/place/getList`,

  // 状态式探测器详情
  getStatusDetectorByCode: `${baseUrl}/statusDetector/getByCode`,

  // 触发式探测器详情
  getTouchDetectorByCode: `${baseUrl}/touchDetector/getByCode`,

  // 状态式探测器详情
  getPumpDetectorByCode: `${baseUrl}/pumpDetector/getByCode`,

  // 配电探测器详情
  getPowerDetectorByCode: `${baseUrl}/powerDetector/getByCode`,

  // 所有网关
  getGatewayDeviceList: `${baseUrl}/gatewayDevice/getList`,

  // 状态式探测器删除
  delStatusDetector: `${baseUrl}/statusDetector/del`,

  // 触发式探测器分页
  delTouchDetector: `${baseUrl}/touchDetector/del`,

  // 配电探测器分页
  delPowerDetector: `${baseUrl}/powerDetector/del`,

  // 泵探测器分页
  delPumpDetector: `${baseUrl}/pumpDetector/del`,

  // 触发式运行监测
  getTouchRunMonitorPage: `${baseUrl}/touchRunMonitor/getPage`,

  // 配电探测运行监测
  getPowerRunMonitorRunMonitor: `${baseUrl}/powerRunMonitor/getRunMonitor`,

  // 泵探测器运行监测
  getPumpRunMonitorPage: `${baseUrl}/pumpRunMonitor/getPage`,

  // 状态式运行监测
  getStatusRunMonitorPage: `${baseUrl}/statusRunMonitor/getPage`,

  // 场所、网关、传感器数量
  getOverViewStatistics: `${baseUrl}/overView/statistics`,

  // 各房间中的探测器的探测数据
  getAllPlaceStatistics: `${baseUrl}/overView/getAllPlaceStatices`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/SmartDetection.js